import axios from 'axios'
import API_URL from '@/router/api'

export const create = (ctx, form) => {
    return new Promise((resolve, reject) => {

        axios.post(API_URL.quiz.create, form)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const update = (ctx, { id, form }) => {
    return new Promise((resolve, reject) => {

        const url = API_URL.quiz.update.replace(/__id__/, id)

        axios.put(url, form)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const deleteQuiz = (ctx, { id }) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.quiz.delete.replace(/__id__/, id)

        axios.delete(url).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}

export const uploadImage = (ctx, form) => {
    return new Promise((resolve, reject) => {
        axios.post(API_URL.upload, form, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const findById = (ctx, id) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.quiz.findById.replace(/__id__/, id)

        axios.get(url).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}

export const findMany = (ctx, query = {}) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.quiz.findMany

        axios.get(url, {
            params: query
        }).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}

export const questionCreate = (ctx, { id, form }) => {
    return new Promise((resolve, reject) => {

        const url = API_URL.quiz.createQuestion.replace(/__id__/, id)

        axios.put(url, form)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const userQuizFindMany = (ctx, data = { query: [] }) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.userQuiz.findMany

        axios.get(url, {
            params: data.query
        }).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}

export const deleteMany = (ctx, { ids }) => {
    return new Promise((resolve, reject) => {

        axios.delete(API_URL.quiz.deleteMany, {
            params: { ids: ids }
        }).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}

export const setUserQuizToFrontpage = (ctx, payload) => {
    return new Promise((resolve, reject) => {
        axios.post(API_URL.quiz.setUserQuizToFrontpage, payload)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const updateUserQuizApproveStatus = (ctx, { id, status, sponsor_setting }) => {
    return new Promise((resolve, reject) => {
        axios.post(API_URL.quiz.updateUserQuizApproveStatus.replace(/__id__/, id), { status, sponsor_setting })
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const checkCloneQuestion = (ctx, payload) => {
    return new Promise((resolve, reject) => {
        axios.post(API_URL.quiz.checkCloneQuestion, payload)
            .then(res => resolve(res))
            .catch(err => reject(err))
    })
}

export const cloneQuestion = (ctx, payload) => {
    return new Promise((resolve, reject) => {
        axios.post(API_URL.quiz.cloneQuestion, payload)
            .then(res => resolve(res))
            .catch(err => reject(err))
    })
}

export const cacheSong = (ctx, playload) => {
    return new Promise((resolve, reject) => {
        axios.post(API_URL.songQuestion.cacheSpotifySong, playload)
            .then(res => resolve(res))
            .catch(err => reject(err))
    })
}

export const approveUserQuizToFrontpage = (ctx, payload) => {
    return new Promise((resolve, reject) => {
        axios.post(API_URL.quiz.approveUserQuizToFrontpage, payload)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const approvalQuizFindMany = (ctx, data = { query: {}, approval_status: [] }) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.userQuiz.findMany

        axios.get(url, {
            params: {
                ...data.query,
                is_approval: true,
                approval_status: data.approval_status
            }
        }).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}

export const approve = (ctx, { id, message, number_approved }) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.quiz.approve.replace(/__id__/, id)

        axios.post(url, {
            message: message,
            number_approved: number_approved
        })
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const rejected = (ctx, { id, message }) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.quiz.reject.replace(/__id__/, id)

        axios.post(url, {
            message: message
        })
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const setIsSponsorQuiz = (ctx, { id, isSponsoreQuiz }) => {

    return new Promise((resolve, reject) => {
        const url = API_URL.quiz.setIsSponsorQuiz.replace(/__id__/, id)

        axios.post(url, {
            is_sponsor_quiz: isSponsoreQuiz
        })
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const updateSponsorSetting = (ctx, { id, setting }) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.quiz.updateSponsorSetting.replace(/__id__/, id)

        axios.put(url, {
            sponsor_setting: setting
        })
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const getSponsorQuizTracker = (ctx, { id }) => {

    return new Promise((resolve, reject) => {
        const url = API_URL.quiz.getSponsorQuizTracker.replace(/__id__/, id)

        axios.get(url)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const getSponsorRankList = (ctx, { id, page }) => {

    return new Promise((resolve, reject) => {

        const url = API_URL.quiz.getSponsorQuizRankList.replace(/__id__/, id)

        axios.get(url, {
            params: { page }
        })
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const exportSponsorQuizRankXlsx = (ctx, { id }) => {
    return new Promise((resolve, reject) => {

        const url = API_URL.quiz.exportSponsorQuizRankXlsx.replace(/__id__/, id)

        axios.get(url)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const deleteSponsorQuizRow = (ctx, { id, rowId }) => {
    return new Promise((resolve, reject) => {

        const url = API_URL.quiz.deleteSponsorQuizRow.replace(/__id__/, id)
            .replace(/__rowId__/, rowId)

        axios.delete(url)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const getEmbed = (ctx, { id }) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.quiz.getEmbed.replace(/__id__/, id)
        axios.get(url)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const getSchoolSubjectById = (ctx, { id }) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.quiz.getSchoolSubjectById.replace(/__id__/, id)
        axios.get(url)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const schoolQuizFindMany = (ctx, data = { id: '', query: [] }) => {

    return new Promise((resolve, reject) => {

        const url = API_URL.schoolQuiz.findMany.replace(/__id__/, data.id)

        axios.get(url, {
            params: {
                ...data.query
            }
        })
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const getQuizCollectionById = (ctx, { id }) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.schoolQuizCollection.getQuizCollectionById.replace(/__id__/, id)
        axios.get(url)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const updatePinQuiz = (ctx, { id, form }) => {
    return new Promise((resolve, reject) => {

        const url = API_URL.quiz.updatePinQuiz.replace(/__id__/, id)

        axios.put(url, form)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

const chatGPTAxios = () => {
    return axios.create({
        baseURL: process.env.VUE_APP_CHATGPT_BASE_URL
    })
}

export const generateAiDescription = (ctx, { title }) => {
    return new Promise((resolve, reject) => {

        const request = chatGPTAxios()

        request
            .post(API_URL.chatGPT.generateQuizDescription, { title }, {
                headers: {
                    'x-bypass-recaptcha': true
                }
            })
            .then(res => resolve(res))
            .catch(err => reject(err))
    })
}


export const generateAiImage = (ctx, { prompt }) => {
    return new Promise((resolve, reject) => {

        const request = chatGPTAxios()

        request
            .post(API_URL.chatGPT.generateAiImage, { prompt }, {
                headers: {
                    'x-bypass-recaptcha': true
                }
            })
            .then(res => resolve(res))
            .catch(err => reject(err))
    })
}

export const generateQuizSeoKeyword = (ctx, { title }) => {
    return new Promise((resolve, reject) => {

        const request = chatGPTAxios()

        request
            .post(API_URL.chatGPT.generateQuizSeoKeyword, { title })
            .then(res => resolve(res))
            .catch(err => reject(err))
    })
}

export const findManyCountry = (ctx, params) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.quiz.findManyCountry

        axios.get(url, { params }).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}

export const generateAiBackground = (ctx, { image }) => {
    return new Promise((resolve, reject) => {

        const request = chatGPTAxios()

        request
            .post(API_URL.chatGPT.generateAiBackground, { image }, {
                headers: {
                    'x-bypass-recaptcha': true
                }
            })
            .then(res => resolve(res))
            .catch(err => reject(err))
    })
}
